import React from 'react'

import {
  makeStyles,
  useTheme,
  useMediaQuery,
  Typography,
  FilePreview,
  Grid,
  HtmlContent,
  ImagePlaceholder
} from '@paintscout/ui'
import type { MuiTheme as Theme } from '@paintscout/ui'
import type { PresentationSectionProps } from '../../'

const useStyles = makeStyles((theme: Theme) => {
  return {
    root: {},
    content: {},
    image: {
      '& img': {
        borderRadius: theme.spacing(1)
      }
    }
  }
})

export default function ThreeColumnPresentationSection(props: PresentationSectionProps) {
  const { section, WrapperComponent, showHelp } = props

  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const responsiveSpacing = isMobile ? 3 : 6

  const classes = useStyles(props)
  const fields = section?.fields ?? ({} as any)
  const { title } = section
  const { leftText, leftImage } = fields
  const { centerText, centerImage } = fields
  const { rightText, rightImage } = fields
  const leftType = fields?.leftType ?? 'image'
  const centerType = fields?.centerType ?? 'text'
  const rightType = fields?.rightType ?? 'text'

  const alignItems = getAlignment(fields?.verticalAlign)

  return (
    <WrapperComponent {...props}>
      <Grid container spacing={3}>
        {title && (
          <Grid item md={12}>
            <Typography variant={'h2'}>{title}</Typography>
          </Grid>
        )}
        <Grid item md={12}>
          <Grid container spacing={responsiveSpacing} alignItems={alignItems}>
            <Grid item md={4}>
              {leftType === 'text' && <HtmlContent content={leftText} classes={{ root: classes.content }} />}
              {leftType === 'image' && (
                <>
                  {leftImage && <FilePreview classes={{ root: classes.image }} file={leftImage} />}
                  {!leftImage && showHelp && <ImagePlaceholder width={'100%'} height={150} title={'Image'} />}
                </>
              )}
            </Grid>

            <Grid item md={4}>
              {centerType === 'text' && <HtmlContent content={centerText} classes={{ root: classes.content }} />}
              {centerType === 'image' && (
                <>
                  {centerImage && <FilePreview classes={{ root: classes.image }} file={centerImage} />}
                  {!centerImage && showHelp && <ImagePlaceholder width={'100%'} height={150} title={'Image'} />}
                </>
              )}
            </Grid>

            <Grid item md={4}>
              {rightType === 'text' && <HtmlContent content={rightText} classes={{ root: classes.content }} />}
              {rightType === 'image' && (
                <>
                  {rightImage && <FilePreview classes={{ root: classes.image }} file={rightImage} />}
                  {!rightImage && showHelp && <ImagePlaceholder width={'100%'} height={150} title={'Image'} />}
                </>
              )}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </WrapperComponent>
  )

  function getAlignment(align: string) {
    switch (align) {
      case 'top':
        return 'flex-start'
      case 'middle':
        return 'center'
      case 'bottom':
        return 'flex-end'
      default:
        return 'flex-start'
    }
  }
}
